import { Inject, Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AppThresholdConfigService {

    private config: Object = null;
    private env:    Object = null;

    constructor(private http: Http) {

    }

    /**
     * Use to get the data found in the second file (config file)
     */
    public getConfig(key: any) {
        return this.config[key];
    }

    /**
     * Use to get the data found in the first file (env file)
     */
    public getEnv(key: any) {
        return this.env[key];
    }
    
    public load() {

        return new Promise((resolve, reject) => {
            this.http.get('/api/configuration')
                .map( res => res.json() )
                .catch((error: any) => {
                    console.error('Error reading configuration file');
                    resolve(error);
                    return Observable.throw(error.json().error || 'Server error');
                })
                .subscribe( (responseData: any) => {
                    if (responseData) {
                        this.config = responseData;
                        resolve(true);
                    } else {
                        console.error('Env config file "env.json" is not valid');
                        resolve(true);
                    }
                })
        });      
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/app-threshold-config.service.ts